import Vue from 'vue'
import { get } from '@/utils/ajax'
export const debounce = (fn, ms = 0) => {
  let timeoutId
  return function (...args) {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => fn.apply(this, args), ms)
  }
}

export const throttle = (fn, wait) => {
  let updateTime = Date.now()
  return (...args) => {
    const now = Date.now()
    if (now - updateTime > wait) {
      fn.apply(this, args)
      updateTime = now
    }
  }
}

export const isEmpty = function (obj) {
  for (const key in obj) {
    return true
  }
  return false
}

export const getScrollTop = function (element) {
  if (element === window) {
    return Math.max(window.pageYOffset || 0, document.documentElement.scrollTop)
  }

  return element.scrollTop
}

export const getVisibleHeight = function (element) {
  if (element === window) {
    return document.documentElement.clientHeight
  }

  return element.clientHeight
}

export const getScrollEventTarget = function (element) {
  let currentNode = element
  // bugfix, see http://w3help.org/zh-cn/causes/SD9013 and http://stackoverflow.com/questions/17016740/onscroll-function-is-not-working-for-chrome
  while (
    currentNode &&
    currentNode.tagName !== 'HTML' &&
    currentNode.tagName !== 'BODY' &&
    currentNode.nodeType === 1
  ) {
    const overflowY = getComputedStyle(currentNode).overflowY
    if (overflowY === 'scroll' || overflowY === 'auto') {
      return currentNode
    }
    currentNode = currentNode.parentNode
  }
  return window
}

export const getElementTop = function (element) {
  if (element === window) {
    return getScrollTop(window)
  }
  return element.getBoundingClientRect().top + getScrollTop(window)
}

export const getComputedStyle = Vue.prototype.$isServer
  ? {}
  : document.defaultView.getComputedStyle

/**
 * 过滤视频、课件、任务单等附件名称
 * @param {String} fileUrl - 资源名称
 */
export const formatFileName = (fileUrl) => {
  const reg = /[^/]*?\.(pdf|mp4|bcm|sb3|sb2|png|jpg|gif|py|hex)$/i
  return fileUrl && fileUrl.match(reg)[0]
}

/**
 * 引入svg
 * @param {String} resolve - 资源
 */
export const importSvg = function(resolve) {
  const cache = {}
  resolve.keys().forEach(key => {
    const component = resolve(key)
    component.name = key.slice(2).replace('.', '-')
    cache[key] = component
  })
  return Object.freeze(cache)
}

// 小数转百分比
export const toPercent = (point) => {
  let str = Number(point * 100).toFixed(1)
  str += '%'
  return str
}

// 微信分享
export const WeChatShare = async (shareInfo) => {
  const configInfo = await get(`${CONFIG.api_edu}/home/share/weixin/jssdk/config?url=${encodeURIComponent(location.href.split('#')[0])}`, void 0, { ignoreMsg: true })
  window.wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: configInfo.app_id, // 必填，企业号的唯一标识，此处填写企业号corpid
    timestamp: configInfo.timestamp, // 必填，生成签名的时间戳
    nonceStr: configInfo.nonce_str, // 必填，生成签名的随机串
    signature: configInfo.signature, // 必填，签名，见附录1
    jsApiList: [
      'checkJsApi',
      'onMenuShareTimeline',
      'onMenuShareAppMessage',
      'onMenuShareQQ',
      'onMenuShareQQ'
    ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
  })
  window.wx.ready(() => {
    window.wx.onMenuShareTimeline({
      title: shareInfo.title, // 分享标题
      link: shareInfo.link, // 分享链接，该链接域名必须与当前企业的可信域名一致
      imgUrl: shareInfo.imgUrl, // 分享图标
      success: function () {
        // 用户确认分享后执行的回调函数
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
      }
    })

    window.wx.onMenuShareAppMessage({
      title: shareInfo.title, // 分享标题
      desc: shareInfo.desc, // 分享描述
      link: shareInfo.link, // 分享链接，该链接域名必须与当前企业的可信域名一致
      imgUrl: shareInfo.imgUrl, // 分享图标
      type: '', // 分享类型,music、video或link，不填默认为link
      dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
      success: function () {
        // 用户确认分享后执行的回调函数
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
      }
    })

    window.wx.onMenuShareQQ({
      title: shareInfo.title, // 分享标题
      desc: shareInfo.desc, // 分享描述
      link: shareInfo.link, // 分享链接
      imgUrl: shareInfo.imgUrl, // 分享图标
      success: function () {
        // 用户确认分享后执行的回调函数
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
      }
    })

    window.wx.onMenuShareQZone({
      title: shareInfo.title, // 分享标题
      desc: shareInfo.desc, // 分享描述
      link: shareInfo.link, // 分享链接
      imgUrl: shareInfo.imgUrl, // 分享图标
      success: function () {
        // 用户确认分享后执行的回调函数
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
      }
    })

    window.wx.error(function (res) {
      console.log(res)
      // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
    })
  })
}
